export enum PercentageUnits {
  Percent,
  Ppm,
}
